/*
 * nf-search-partial.js — completa a busca preditiva com correspondencia parcial.
 *
 * A busca da Shopify indexa por PREFIXO de palavra: "cach" acha "CACHIMBO",
 * mas "chimb" e "himbo" nao acham nada, e a Search API nao aceita curinga no
 * inicio. Este script mantem a busca nativa como principal (relevancia do
 * servidor, cobre tag e descricao) e ACRESCENTA os produtos cujo nome contem o
 * trecho digitado em qualquer posicao.
 *
 * O indice sai de templates/collection.nf-search-index.liquid, e' buscado uma
 * unica vez por sessao e guardado em sessionStorage.
 *
 * Nao altera predictive-search.js: observa o resultado que o Dawn injeta e
 * completa a lista depois.
 */
(function () {
  if (window.NFSearchPartial) return;

  const behavior = window.NFSearchBehavior;
  if (!behavior) return;

  const PRODUCTS_LIST_ID = 'predictive-search-results-products-list';
  const CACHE_KEY = 'nf-search-index-v1';
  const MAX_RESULTS = 10;
  const MAX_PAGES = 20;

  let indexPromise = null;

  function readCache() {
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(products) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(products));
    } catch (error) {
      /* sessionStorage cheio ou bloqueado: seguir sem cache */
    }
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;

    const cached = readCache();
    if (cached) {
      indexPromise = Promise.resolve(cached);
      return indexPromise;
    }

    const root = (window.routes && window.routes.root_url) || '';
    const base = behavior.buildIndexUrl(root);

    indexPromise = (async () => {
      const products = [];
      let page = 1;
      while (page && products.length < 2000 && page <= MAX_PAGES) {
        const response = await fetch(page > 1 ? `${base}&page=${page}` : base);
        if (!response.ok) break;
        const data = await response.json();
        if (Array.isArray(data.products)) products.push(...data.products);
        page = data.next;
      }
      writeCache(products);
      return products;
    })().catch(() => []);

    return indexPromise;
  }

  // So aceita caminho interno da propria loja. Barra javascript:, data: e host
  // externo — o indice vem do tema, mas o link nunca e' montado as cegas.
  function safePath(value) {
    const raw = String(value == null ? '' : value).trim();
    return /^\/[^/\\]/.test(raw) ? raw : '';
  }

  // image_url devolve URL do CDN da Shopify (`https://` ou `//cdn...`),
  // entao a regra do link interno nao serve aqui.
  function safeImage(value) {
    const raw = String(value == null ? '' : value).trim();
    return /^(https:\/\/|\/\/)[^/\\]/.test(raw) ? raw : '';
  }

  // Espelha o markup que sections/predictive-search.liquid gera para produto.
  // Montado com API de DOM: texto entra por textContent, nunca por innerHTML.
  function buildItem(product, position) {
    const href = safePath(product.url);
    if (!href) return null;

    const li = document.createElement('li');
    li.id = `predictive-search-option-product-nf-${position}`;
    li.className = 'predictive-search__list-item';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('data-nf-partial-result', '');

    const link = document.createElement('a');
    link.href = href;
    link.className = 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text';
    link.tabIndex = -1;

    const imageSrc = safeImage(product.image);
    if (imageSrc) {
      const img = document.createElement('img');
      img.className = 'predictive-search__image';
      img.src = imageSrc;
      img.alt = '';
      img.width = 50;
      img.height = 50;
      img.loading = 'lazy';
      link.appendChild(img);
    }

    const content = document.createElement('div');
    content.className = 'predictive-search__item-content';

    const heading = document.createElement('p');
    heading.className = 'predictive-search__item-heading h5';
    heading.textContent = String(product.title == null ? '' : product.title);

    content.appendChild(heading);
    link.appendChild(content);
    li.appendChild(link);
    return li;
  }

  function findHost(node) {
    return node && node.closest ? node.closest('predictive-search') : null;
  }

  function currentTerm(host) {
    const input = host.querySelector('input[type="search"], input[name="q"]');
    return input ? input.value : '';
  }

  function listedUrls(list) {
    return new Set(
      [...list.querySelectorAll('a[href]')].map((a) => (a.getAttribute('href') || '').split('?')[0]),
    );
  }

  // Sem nenhum resultado nativo o Dawn nao renderiza a lista de produtos — mostra
  // so "nenhum resultado". Como esse e' justamente o caso de "chimb", a estrutura
  // e' criada aqui, com as mesmas classes da secao.
  function ensureProductsList(host) {
    const existing = host.querySelector(`#${PRODUCTS_LIST_ID}`);
    if (existing) return existing;

    const results = host.querySelector('#predictive-search-results');
    if (!results) return null;

    const wrapper = document.createElement('div');
    wrapper.className =
      'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions';

    const group = document.createElement('div');
    group.className = 'predictive-search__result-group';

    const inner = document.createElement('div');

    const heading = document.createElement('h2');
    heading.id = 'predictive-search-products';
    heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    heading.textContent = host.getAttribute('data-products-label') || 'Produtos';

    const list = document.createElement('ul');
    list.id = PRODUCTS_LIST_ID;
    list.className = 'predictive-search__results-list list-unstyled';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-labelledby', 'predictive-search-products');

    inner.appendChild(heading);
    inner.appendChild(list);
    group.appendChild(inner);
    wrapper.appendChild(group);
    results.appendChild(wrapper);
    return list;
  }

  function hideEmptyState(host) {
    host.querySelectorAll('#predictive-search-results > :not(.predictive-search__results-groups-wrapper)')
      .forEach((node) => {
        node.setAttribute('hidden', '');
        node.setAttribute('data-nf-hidden-empty-state', '');
      });
  }

  async function complete(host) {
    const term = currentTerm(host);
    if (!behavior.canPredict(term)) return;

    // O indice e' carregado ANTES de tocar no DOM. O Dawn substitui o conteudo
    // dos resultados quando a resposta dele chega; se a lista fosse criada antes
    // dessa espera, a injecao cairia num elemento ja removido do documento.
    const index = await loadIndex();
    if (!index.length) return;

    // O termo pode ter mudado enquanto o indice carregava.
    if (currentTerm(host) !== term) return;

    const list = ensureProductsList(host);
    if (!list || !list.isConnected || list.dataset.nfCompletedFor === term) return;
    list.dataset.nfCompletedFor = term;

    const already = listedUrls(list);
    if (already.size >= MAX_RESULTS) return;

    const found = behavior
      .filterIndex(index, term, { limit: MAX_RESULTS })
      .filter((product) => !already.has((product.url || '').split('?')[0]));

    if (!found.length) return;

    const room = MAX_RESULTS - already.size;
    let added = 0;
    found.slice(0, room).forEach((product, i) => {
      const item = buildItem(product, i + 1);
      if (!item) return;
      list.appendChild(item);
      added += 1;
    });

    if (added) {
      hideEmptyState(host);
      host.dispatchEvent(new CustomEvent('nf:partial-results', { detail: { term, added } }));
    }
  }

  // O Dawn troca o innerHTML dos resultados; observamos para completar depois.
  // O agendamento e' por setTimeout, nao requestAnimationFrame: rAF nao dispara
  // em aba sem composicao (segundo plano), e a busca ficaria sem completar.
  function watch(host) {
    if (host.dataset.nfPartialWatched) return;
    host.dataset.nfPartialWatched = 'true';
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        complete(host);
      }, 0);
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('predictive-search').forEach(watch);
  }

  window.NFSearchPartial = { loadIndex, complete };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
